export const MULTI_PARTNER = 'a_plusieurs';
export const SINGLE = 'célibataire';
export const MARIED = 'marié(e)';
export const DIVORCED = 'divorcé(e)';
export const PACTE = 'pacsé(e)';
export const WIDOW = 'veuf(ve)';
export const YES = 'oui';
export const NO = 'non';
export const PM = 'personne_morale';
export const PP = 'personne_physique';
export const CAC_PM = 'morale';
export const CAC_PP = 'physique';
export const SARL = 'SARL';
export const SASU = 'SASU';
export const SAS = 'SAS';
export const EURL = 'EURL';
export const SA = 'SA';
export const SC = 'SC';
export const SCA = 'SCA';
export const SCS = 'SCS';
export const MONSIEUR = 'M.';
export const MADAME = 'Mme';
export const TIERS = 'un_tiers';
export const PARTNER = "l_associe_de_l'EURL";
export const REQUIRED = 'Champs requis';
export const DATE_RIQUIRED = 'Une date est necessaire';
export const DATE_CONSTRAINTE = `la date doit être antérieure à la date d'aujourd'hui`;
export const BANK = 'banque';
export const NOTARIE = 'notaire';
export const BBF_NOTARIE = 'be_business_focus';
export const HEAD_OFFICE_AT_SEO = 'chez_gerant';
export const HEAD_OFFICE_IN_LOCAL = 'local';
export const HEAD_OFFICE_IN_DOMICILIATION = 'en_domiciliation';
export const OWNER = 'Proprietaire';
export const TENANT = 'Locataire';
export const OTHER = 'autre';
export const IS = 'is';
export const IR = 'ir';

export const pacsTypes = [
  {
    label: 'De la séparation des patrimoines',
    value: 'de_la_separation_des_patrimoines',
  },
  { label: "De l'indivision", value: "de_l'indivision" },
];
export const headOfficeLocations = [
  { label: 'Chez le gérant', value: HEAD_OFFICE_AT_SEO },
  { label: 'dans un local', value: HEAD_OFFICE_IN_LOCAL },
  { label: 'En domiciliation', value: HEAD_OFFICE_IN_DOMICILIATION },
];
export const headOfficeLocationsPresident = [
  { label: 'Chez le président', value: HEAD_OFFICE_AT_SEO },
  { label: 'dans un local', value: HEAD_OFFICE_IN_LOCAL },
  { label: 'En domiciliation', value: HEAD_OFFICE_IN_DOMICILIATION },
];
export const taxregime = [
  { label: 'Impôt sur les sociétés', value: 'is' },
  { label: 'Impôt sur le revenu', value: 'ir' },
];
export const proprietaireLocataire = [
  { label: 'Proprietaire', value: OWNER },
  { label: 'Locataire', value: TENANT },
];
export const personTypes = [
  { label: 'Personne physique', value: PP },
  { label: 'Personne morale', value: PM },
];
export const cacTypes = [
  { label: 'Personne physique', value: CAC_PP },
  { label: 'Personne morale', value: CAC_PM },
];
export const genders = [
  { label: 'Monsieur', value: MONSIEUR },
  { label: 'Madame', value: MADAME },
];
export const familySituations = [
  { label: 'Célibataire', value: 'célibataire' },
  { label: 'Marié(e)', value: 'marié(e)' },
  { label: 'Divorcé(e)', value: 'divorcé(e)' },
  { label: 'Pacsé(e)', value: 'pacsé(e)' },
  { label: 'Veuf(ve)', value: 'veuf(ve)' },
];

export const weddingStatuts = [
  { label: 'Séparation de biens', value: 'separation_de_biens' },
  { label: 'Communauté universelle', value: 'communaute_universelle' },
  { label: 'Communauté de biens', value: 'communaute_de_biens' },
];

export const regimeSociale = [
  { label: 'général', value: 'régime général' },
  { label: 'agricole', value: 'régime agricole' },
  {
    label: 'Non salarié/agricole',
    value: 'régime non salarié non agricole',
  },
  { label: 'ENIM', value: 'ENIM' },
  { label: 'Autre', value: OTHER },
];

export const juridicForms = [
  { label: SARL, value: SARL },
  { label: SASU, value: SASU },
  { label: SAS, value: SAS },
  { label: EURL, value: EURL },
  { label: SA, value: SA },
  { label: SC, value: SC },
  { label: SCA, value: SCA },
  { label: SCS, value: SCS },
];

export const yesNo = [
  { label: YES, value: YES },
  { label: NO, value: NO },
];

export const dureeExercieCAC = [
  { label: '3 exercices', value: '3' },
  { label: '6 exercices', value: '6' },
];

export const numberOfContract = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
];

export const FIVE_FIRST_NUMBER_LIST = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];

export const debutActivities = [
  { label: 'Immediatement', value: 'immediatement' },
  { label: 'Plus tard', value: 'date_externe' },
  { label: 'Sans activité', value: 'sans_activite' },
];
